import ajax from "./request.js";

const href =
  process.env.NODE_ENV === "production"
    ? `https://${window.location.host}/api/cloud/file/thumb/admin`
    : "/api/cloud/file/thumb/admin";

function status() {
  return ajax(`${href}/status`, { method: "POST", data: {} });
}

function setEnabled(enabled) {
  return ajax(`${href}/setEnabled`, { method: "POST", data: { enabled } });
}

function runNow() {
  return ajax(`${href}/runNow`, { method: "POST", data: {} });
}

function runs(limit = 3) {
  return ajax(`${href}/runs`, { method: "POST", data: { limit } });
}

function runItems(runId) {
  return ajax(`${href}/runItems`, { method: "POST", data: { runId } });
}

function failures() {
  return ajax(`${href}/failures`, { method: "POST", data: {} });
}

function retryFailures() {
  return ajax(`${href}/retryFailures`, { method: "POST", data: {} });
}

export default { status, setEnabled, runNow, runs, runItems, failures, retryFailures };
